import * as React from "react";
import { UitkCardContent, UitkCardTextSegment } from "uitk-react-cards";
import { UitkLink } from "uitk-react-link";
import LazyLoad from "react-lazyload";
import { liveAnnounce } from "uitk-react-utils";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { formatText } from "bernie-l10n";

const localizeSearchMonth = (month: string) =>
  formatText("tripCost.popover.searchMonth", month) || `Search ${month}`;

export interface PopoverProps {
  containerWidth: number;
  x: number;
  y: number;
  title: string;
  linkText: string;
  linkAction: () => any;
  isOpen?: boolean;
}

type EventClick = React.MouseEvent<HTMLDivElement, MouseEvent>;

export const Popover = (props: PopoverProps) => {
  const elemRef = React.useRef(null);
  const element = (elemRef && elemRef.current) || { clientWidth: 90 };
  const preventClose = React.useCallback((e: EventClick) => e.stopPropagation(), []);
  const linkAction = React.useCallback(
    (e: EventClick) => {
      e.preventDefault();
      props.linkAction();
    },
    [props.linkAction]
  );

  const containerWidth = props.containerWidth || 0;

  const positionX =
    props.x + element.clientWidth / 2 > containerWidth
      ? containerWidth - element.clientWidth
      : props.x - element.clientWidth / 2;

  const style = React.useMemo(
    () => ({ transform: `translate(${positionX < 0 ? 17 : positionX}px, 50%` }),
    [props.y, props.x]
  );

  React.useEffect(
    () => {
      if (props.isOpen) {
        liveAnnounce(`${props.title}: ${props.linkText}`);
      }
    },
    [props.title, props.linkText, props.isOpen]
  );

  return props.isOpen ? (
    <LazyLoad>
      <div className="zoomAnimation" onClick={preventClose}>
        <div ref={elemRef} className="Popover uitk-card elevation-8" style={style}>
          <UitkCardContent>
            <UitkCardTextSegment className="uitk-type-center">
              <span className="uitk-type-300 uitk-type-bold">{props.title}</span>
              <UitkLink>
                <TrackedLink
                  moduleName="tripCostEstimator"
                  rfrr="link-popover"
                  href="#"
                  onClick={linkAction}
                >
                  {localizeSearchMonth(props.linkText)}
                </TrackedLink>
              </UitkLink>
            </UitkCardTextSegment>
          </UitkCardContent>
        </div>
      </div>
    </LazyLoad>
  ) : null;
};

export default Popover;
